<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
                <span class="field-title">Nome</span>
                <span class="field-value">{{customer.name}}</span><br>
                <span class="field-title">Cognome</span>
                <span class="field-value">{{customer.lastname}}</span><br>
                <span class="field-title">Telefono</span>
                <span class="field-value">{{customer.telephone}}</span><br>
                <span class="field-title">Cellulare</span>
                <span class="field-value">{{customer.mobilePhone}}</span><br>
                <span class="field-title">E-mail</span>
                <span class="field-value">{{customer.email}}</span><br>
                <span class="field-title">Luogo di nascita</span>
                <span class="field-value">{{customer.birthPlace}}</span><br>
                <span class="field-title">Compleanno</span>
                <span class="field-value">{{customer.birthday | date}}</span><br>
                <span class="field-title">Cod. Fiscale</span>
                <span class="field-value">{{customer.fiscalCode}}</span><br>
                <span class="field-title">Residenza</span>
                <span class="field-value">{{customer.residenceStreet}}, {{customer.residenceStreetNumber}} {{customer.residenceZipCode}} {{customer.residenceCity}}</span><br>
                <span class="field-title">Ultima modifica</span>
                <span class="field-value">{{customer.lastEdit | datetime}}</span><br>
                <span class="field-title">Animali</span>
                <span class="field-value">
                    <Pet
                        v-for="petId in customer.petIds" 
                        :key="petId" 
                        :petId = "petId"
                    /><br>
                    <v-btn
                        color="primary"
                        text
                        @click="$router.push({name: 'petAdd', params:{customerId:customer.id}});"
                    >
                        Aggiungi nuovo
                    </v-btn>
                </span><br>
        </v-layout>
        <v-dialog
            v-model="showDeletionDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Conferma eliminazione
                </v-card-title>
                <v-card-text>
                    Vuoi davvero cancellare questo cliente?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDeletionDialog = false"
                >
                    No, annulla
                </v-btn>
                <v-btn
                    color="red"
                    style="color:white"
                    text
                    @click="deleteCustomer();showDeletionDialog = false"
                >
                    Si, elimina
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            style="bottom:20px;"
            @click="$router.push({name: 'customerEdit', params:{customerId:customer.id}});"
            > <v-icon style="font-size:40px;padding-top:5px;">edit</v-icon>
        </v-btn>
        <v-btn
            color="#f44336"
            dark
            absolute
            bottom
            left
            fab
            @click.native="showDeletionDialog=true"
            style="bottom:20px;"
            > <v-icon style="font-size:40px;padding-top:5px;">delete</v-icon>
        </v-btn>
        <v-snackbar v-model="showDeletedToast">
            Cliente eliminato!
        </v-snackbar>
    </v-container>
</template>

<script>
const axios = require('axios').default;
import Pet from '@/partial/Pet.vue'
export default {
    name: 'Customer',
    components: {
        Pet
    },
    data: function(){
        return{
            showDeletionDialog: false,
            showDeletedToast: false,
            searchedText: "",
            customer:{}
        };
    },
    mounted: function(){
        let vm = this;
        vm.getCustomer();
    },
    methods:{
        getCustomer(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getCustomer.php?customerId="+vm.$route.params.customerId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.customer = response.data.resource;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        },
        deleteCustomer(){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "deleteCustomer.php",
                data: {
                    "customerId":vm.$route.params.customerId
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.showDeletedToast = true;
                    vm.$router.push({name: 'customers'});
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>
